import React from 'react';
import styled from 'styled-components';
import { formatPrice } from '../../../utils/price-utils';

const DiscountedPrice = styled.span`
  font-size: ${16/16}rem;
  text-decoration: line-through;
  align-self: flex-end;
  line-height: 1rem;
  text-decoration: line-through;
  padding-right: .3rem;
`;

const renderDiscountPrice = (price, localeConfig) => {
  if (price.price_value_original) {
    const originalPrice = formatPrice(price.price_value_original, localeConfig('units.currency.identifier'), localeConfig('units.currency.locale'));
    return (
      <DiscountedPrice>
        { originalPrice }
      </DiscountedPrice>
    );
  } else {
    return null;
  }
};

export {
  DiscountedPrice,
  renderDiscountPrice
}


// WEBPACK FOOTER //
// ./src/modules/booking/components/DiscountedPrice.js